import { useSnapshot } from 'valtio';

import * as authStore from '@cartwhl/common/stores/authStore';
import Button from '@cartwhl/ui/input/Button';

import NavigationLink from './NavigationLink';
import useAppletsUrl from '../hooks/useAppletsUrl';

interface StartOrLaunchButtonProps {
  anonymousHref?: string;
  className?: string;
}

export default function StartOrLaunchButton({
  anonymousHref = '/pricing',
  className,
}: StartOrLaunchButtonProps) {
  const { authStatus } = useSnapshot(authStore.state);
  const appletsUrl = useAppletsUrl();

  if (authStatus === 'user') {
    if (!appletsUrl) {
      return (
        <Button type="button" variant="cta" className={className} disabled>
          Launch Cartwheel
        </Button>
      );
    }

    return (
      <Button as="a" href={appletsUrl} variant="cta" className={className}>
        Launch Cartwheel
      </Button>
    );
  }

  return (
    <Button
      as={NavigationLink}
      href={anonymousHref}
      variant="cta"
      className={className}
    >
      Start free trial
    </Button>
  );
}
